<div>
	@if (showForm()) {
		@if (edit(); as edit) {
			<nz-tabs>
				<nz-tab nzTitle="Edit Content">
					<app-setup-wizard-content-form
						[activityUuid]="edit.before!.activity_uuid!"
						[loading]="loading()"
						[edit]="edit.after || edit.before || null"
						(onClear)="onFormClear()"
						(onSubmit)="onFormSubmit($event)"
					></app-setup-wizard-content-form>
				</nz-tab>
			</nz-tabs>
		} @else {
			<h1>Edit is missing...</h1>
		}
	} @else {
		<div class="top-buttons">
			<button
				nz-button
				nzType="primary"
				(click)="onAdd()"
				class="add-button"
				[disabled]="true"
				nz-tooltip="To add a new piece of content go to the activity tab and edit the activity you want to add the content to."
			>
				Add
			</button>

			<div>
				<app-setup-wizard-upload-csv-button></app-setup-wizard-upload-csv-button>

				<app-setup-wizard-download-csv-button
					[key]="SetupWizardPayloadObjectKeys.contents"
				></app-setup-wizard-download-csv-button>
			</div>
		</div>
	}
</div>
<div>
	<app-setup-wizard-contents-table
		[rubricCode]="rubricCode()"
		[selectedRow]="edit()"
		(onEdit)="onEdit($event)"
		(onToggleDisable)="onToggleDisable($event)"
		(onRemove)="onRemove($event)"
		(onReset)="onReset($event)"
	></app-setup-wizard-contents-table>
</div>
